/**
 * Maps a top-level app route to the permission code required to open it.
 * Used by both the route guard (block navigation) and the sidebar (hide menu items),
 * so the two never drift apart. Routes not listed here are unrestricted (client-side);
 * the backend still enforces every request.
 */
export const ROUTE_PERMISSIONS: Record<string, string> = {
    '/employees': 'employees.access',
    '/work-schedules': 'work_schedules.access',
    '/attendance-policies': 'attendance.access',
    '/attendance': 'attendance.access',
    '/contracts': 'contracts_benefits.access',
    '/payrolls': 'payroll.access',
    '/departments': 'departments.access',
    '/offices': 'offices.access',
    '/approvals': 'hr_requests.access',
    '/sites': 'sites.access',
    '/projects': 'projects.access',
    '/qs': 'quantity_survey.access',
    '/vendors': 'vendors.access',
    '/purchase-orders': 'purchase_orders.access',
    '/incoming-invoices': 'incoming_invoices.access',
    '/payment-requests': 'payment_requests.access',
    '/trust-payment-requests': 'trust_payment_requests.access',
    '/expenses': 'expenses.access',
    '/vat-reports': 'vat_reports.access',
    '/authorization': 'rbac.access',
    '/system-config': 'system_settings.access',
};

/**
 * Returns the permission code required for a URL/route path, or null if unrestricted.
 * Picks the longest matching prefix so nested paths resolve to their module.
 */
export function matchRoutePermission(url: string): string | null
{
    const path = url.split('?')[0].split('#')[0];
    let best: string | null = null;
    let bestLen = -1;

    for (const key of Object.keys(ROUTE_PERMISSIONS)) {
        if ((path === key || path.startsWith(key + '/')) && key.length > bestLen) {
            best = ROUTE_PERMISSIONS[key];
            bestLen = key.length;
        }
    }

    return best;
}
